import { gql } from "@apollo/client"

/** Minimal query for wallet balance check before payment. Use when you only need wallet.balance. */
export const GET_ME_WALLET = gql`
  query MeWallet {
    me {
      id
      wallet {
        id
        balance
        currency
      }
    }
  }
`

export const GET_ME = gql`
  query Me {
    me {
      id
      email
      role
      authProvider
      lastLoginAt
      notificationsConsent
      termsAcceptedAt
      profile {
        id
        firstName
        lastName
        phone
        dateOfBirth
        gender
        avatar
        location {
          address
          city
          state
          country
          zipCode
        }
        bio
      }
      wallet {
        id
        balance
        currency
      }
      staff {
        id
        role
        permissions
        dateJoined
      }
      createdAt
      updatedAt
    }
  }
`

